import usePageViewLogger from '../hooks/usePageViewLogger';
import FloatingBanner from '../components/FloatingBanner';

const HomePage = () => {

  usePageViewLogger();

  return (
    <div className="App">
      <FloatingBanner />
      <div className="content">
        {/* Your main content goes here */}
        <p>Er komt iets aan, blijf kijken!</p>
      </div>

    </div>
  );
};

export default HomePage;
